import React, { Component } from "react";
import Slide from "react-reveal";

class Resume extends Component {
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    if (!this.props.data) return null;

    //const skillmessage = "Your value here";
    const ambiental = this.props.data.ambiental.map(function (ambiental) {
      return (
        <div key={ambiental.school}>
          <h3>{ambiental.school}</h3>
          <p className="info">
            {ambiental.degree} <span>&bull;</span>
            <em className="date">{ambiental.graduated}</em>
          </p>
          <p>{ambiental.description}</p>
        </div>
      );
    });

    const culture = this.props.data.culture.map(function (culture) {
      return (
        <div key={culture.company}>
          <h3>{culture.company}</h3>
          <p className="info">
            {culture.title} <span>&bull;</span>
            <em className="date">{culture.years}</em>
          </p>
          <p>{culture.description}</p>
        </div>
      );
    });

  /*  const skills = this.props.data.skills.map((skills) => {
      const backgroundColor = this.getRandomColor();
      const className = "bar-expand " + skills.name.toLowerCase();
      const width = skills.level;

      return (
        <li key={skills.name}>
          <span style={{ width, backgroundColor }} className={className}></span>
          <em>{skills.name}</em>
        </li>
      );
    });
*/
    const communications = this.props.data.communications.map(function (communications) {
      return (
        <div key={communications.company}>
          <h3>{communications.company}</h3>
          <p className="info">
            {communications.title} <span>&bull;</span>
            <em className="date">{communications.years}</em>
          </p>
          <p>{communications.description}</p>
        </div>
      );
    });

    const economy = this.props.data.economy.map(function (economy) {
      return (
        <div key={economy.company}>
          <h3>{economy.company}</h3>
          <p className="info">
            {economy.title} <span>&bull;</span>
            <em className="date">{economy.years}</em>
          </p>
          <p>{economy.description}</p>
        </div>
      );
    });


    const genre = this.props.data.genre.map(function (genre) {
      return (
        <div key={genre.company}>
          <h3>{genre.company}</h3>
          <p className="info">
            {genre.title} <span>&bull;</span>
            <em className="date">{genre.years}</em>
          </p>
          <p>{genre.description}</p>
        </div>
      );
    });

    const technology = this.props.data.technology.map(function (technology) {
      return (
        <div key={technology.company}>
          <h3>{technology.company}</h3>
          <p className="info">
            {technology.title} <span>&bull;</span>
            <em className="date">{technology.years}</em>
          </p>
          <p>{technology.description}</p>
        </div>
      );
    });

    const human_rights = this.props.data.human_rights.map(function (human_rights) {
      return (
        <div key={human_rights.company}>
          <h3>{human_rights.company}</h3>
          <p className="info">
            {human_rights.title} <span>&bull;</span>
            <em className="date">{human_rights.years}</em>
          </p>
          <p>{human_rights.description}</p>
        </div>
      );
    });

    const psycosocial = this.props.data.psycosocial.map(function (psycosocial) {
      return (
        <div key={psycosocial.company}>
          <h3>{psycosocial.company}</h3>
          <p className="info">
            {psycosocial.title} <span>&bull;</span>
            <em className="date">{psycosocial.years}</em>
          </p>
          <p>{psycosocial.description}</p>
        </div>
      );
    });

    return (
      <section id="resume">
        <Slide left duration={1300}>
          <div className="row ambiental">
            <div className="three columns header-col">
              <h1>
                <span>Ambiental</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">{ambiental}</div>
              </div>
            </div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row culture">
            <div className="three columns header-col">
              <h1>
                <span>Cultura/Educación</span>
              </h1>
            </div>

            <div className="nine columns main-col">{culture}</div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row economy">
            <div className="three columns header-col">
              <h1>
                <span>Economía Popular</span>
              </h1>
            </div>

            <div className="nine columns main-col">{economy}</div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row genre">
            <div className="three columns header-col">
              <h1>
                <span>Género</span>
              </h1>
            </div>

            <div className="nine columns main-col">{genre}</div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row technology">
            <div className="three columns header-col">
              <h1>
                <span>Tecnología</span>
              </h1>
            </div>

            <div className="nine columns main-col">{technology}</div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row human_rights">
            <div className="three columns header-col">
              <h1>
                <span>Derechos Humanos</span>
              </h1>
            </div>

            <div className="nine columns main-col">{human_rights}</div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row psycosocial">
            <div className="three columns header-col">
              <h1>
                <span>Psicosocial</span>
              </h1>
            </div>

            <div className="nine columns main-col">{psycosocial}</div>
          </div>
        </Slide>


        <Slide left duration={1300}>
          <div className="row communications">
            <div className="three columns header-col">
              <h1>
                <span>Comunicaciones</span>
              </h1>
            </div>

            <div className="nine columns main-col">{communications}</div>
          </div>
        </Slide>


        
      </section>
    );
  }
}

export default Resume;
